export const APP_ROUTES = {
  home: "/",
  auth: "/auth",
  maintenance: "/maintenance",
  dashboard: "/",
  gasAccount: "/gas-account",
  policies: "/policies",
  policyCreate: "/policies/create",
  policyEdit: (id: string) => `/policies/${id}/edit`,
  policyDetails: (id: string) => `/policies/${id}`,
  ads: "/ads",
  adCreate: "/ads/create",
  adDetails: (id: string) => `/ads/${id}`,
  adEdit: (id: string) => `/ads/${id}/edit`,
  analytics: "/analytics",
  settings: "/settings",
  notFound: "*",
} as const
